
// export const validateField = (name, value) => {
//     switch (name) {
//       case "name":
//         if (!value.trim()) return "Name is required field.";
//         if (isContainNumbers(value)) return "Name cannot contain numbers.";
//         break;
//       case "phone":
//         if (!value.trim()) return "Phone number is required field.";
//         if (!/^\d{10}$/.test(value))
//           return "Please enter a valid phone number.";
//         break;
//       case "email":
//         if (!value.trim()) return "Email is required field.";
//         if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))
//           return "Please enter a valid email address.";
//         break;
//       case "city":
//         if (!value.trim()) return "City is required field.";
//         if (/\d/.test(value)) return "City cannot contain numbers.";
//         break;
//       case "message":
//         if (!value.trim()) return "Message is required field.";
//         break;
//       default:
//         return "";
//     }
//     return "";
//   };

  export const isEmptyData = (setNewErrorJson,name,value,alt) => {
    setNewErrorJson((prev)=>{
    if(!value.trim()){
         return {...prev,[name]:`${alt} is required field`};  
        }
        else{
         const { [name]: removed, ...rest}= prev;              //If field is filled is not empty remove errors
         return rest;
        }
         })
  }
  export const isDropdownSelected = (setNewErrorJson,name,value,alt) => {
    setNewErrorJson((prev)=>{
    if(value ==='Select'){
         return {...prev,[name]:`${alt} is required field`};  
        }
        else{
         const { [name]: removed, ...rest}= prev;              //If field is filled is not empty remove errors
         return rest;
        }
         })
  }
   export const handleValidationCheck = (e,setNewErrorJson) => {
      const{name,value,type,alt}=e.target;
     //alert(type +"::"+alt);
      if(type==="text") {
       isEmptyData(setNewErrorJson,name,value,alt);
       return false;
        }
         else if(type==="email") {
        isEmptyData(setNewErrorJson,name,value,alt);
       return handleValidateEmail(value);
        }
      else if(type==="number") {
       isEmptyData(setNewErrorJson,name,value,alt);
        return false;
        }
       else if(type==="select-one") {
       isEmptyData(setNewErrorJson,name,value,alt);
        return false;
       }
       else if(type==="date") {
         isEmptyData(setNewErrorJson,name,value,alt);
        return false;
       }
       else if(type==="textarea") {
        //Instead of alt value passed name intentionally because alt somehow doesn't work for textarea
         isEmptyData(setNewErrorJson,name,value,name);
       return false;
      }
     //  })

      
  };

  export const handleValidateEmail = (value) => {

   if(value){
      return true;
   }
   else{
     return false;
   }
   
  }

  export const isEmpty = (obj) => Object.keys(obj).length === 0;

  export const isAllFieldsValid = (formFields) =>{ 
    return Object.values(formFields).every(field => field);
  }